import { styled } from '@mui/material';

import { Button } from '../../atoms/Button';
import { type InfiniteScrollTriggerProps, useInfiniteScrollTrigger } from './useInfiniteScrollTrigger';

type Props = InfiniteScrollTriggerProps;

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  paddingBlock: theme.spacing(1),
}));

/**
 * End-of-list sentinel for infinite lists: loads the next page when it scrolls into view.
 * The visible "Voir plus" button stays as a keyboard- and touch-friendly fallback, and shows the loading state.
 */
export function InfiniteScrollTrigger(props: Props) {
  const hook = useInfiniteScrollTrigger(props);

  if (!props.hasMore) {
    return null;
  }

  return (
    <Root ref={hook.sentinelRef} data-testid={props['data-testid'] ?? 'infinite-scroll-trigger'}>
      <Button
        variant="text"
        size="small"
        color="default"
        loading={props.isLoading}
        onClick={props.onLoadMore}
      >
        {hook.label}
      </Button>
    </Root>
  );
}

export type { Props as InfiniteScrollTriggerProps };
